{
  "version": 1,
  "asset_id": "04b9de22-589d-472c-a068-1d40ead78d31",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/04b9de22-589d-472c-a068-1d40ead78d31/mark-128.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/04b9de22-589d-472c-a068-1d40ead78d31/mark-128.webp",
  "original_filename": "mark-128.webp",
  "size": 6264,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:18:10Z"
}
